import styled, { css } from "styled-components";
import tw from "twin.macro";

import { BoxSizingStyle } from "../BoxSizingStyle";
import { Bubble } from "../Bubble";
import { FontStyle } from "../FontStyle";

export const StyledMenu = styled(Bubble)<{ $mode: string }>`
  ${tw`tw-bg-page-paper-main tw-border-border-primary tw-my-1 tw-overflow-auto`}

  ${FontStyle}
  ${BoxSizingStyle}
  
  color: var(--color-theme-700);
  a:focus,
  a:active {
    outline: none;
  }

  ${(props) =>
    props.$mode === "normal" &&
    css`
      width: 260px;
    `}

  ${(props) =>
    props.$mode === "wider" &&
    css`
      width: 350px;
    `}

  ${(props) =>
    props.$mode === "tiny" &&
    css`
      width: 180px;
    `}

  ${(props) =>
    props.$mode === "widest" &&
    css`
      width: 590px;
    `}
`;
StyledMenu.displayName = "StyledMenu";

export const StyledMenuFooter = styled.div`
  ${tw`tw-flex tw-px-2 tw-py-1`}

  display: flex;
  border-top: 1px solid var(--border-primary);
  height: 32px;
  align-items: center;
`;
StyledMenuFooter.displayName = "StyledMenuFooter";

export const StyledMenuHeader = styled.div`
  ${tw`tw-flex tw-items-center tw-justify-between tw-px-2 tw-py-1`}

  border-bottom: 1px solid var(--border-primary);
  height: 32px;
`;
StyledMenuHeader.displayName = "StyledMenuHeader";
